module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showModal) ? _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.modalContent)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32490c60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Modals/Modal.vue
// module id = 844
// module chunks = 2